import { Link, NavLink, useLocation } from "react-router-dom";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/quote", label: "Request Quote" },
  { to: "/assessment", label: "Site Assessment" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-slate-200"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img
            src="/logo.png"
            alt="Greenville Integrated Solutions"
            className="h-20 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#1E3A6B]" : "text-slate-700 hover:text-slate-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/quote">
            <Button
              data-testid="nav-cta-quote-btn"
              className="rounded-none bg-[#1E3A6B] hover:bg-[#172F58] text-white font-medium"
            >
              Get a Quote
            </Button>
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-slate-700"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base font-medium text-slate-800"
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/quote">
              <Button
                data-testid="mobile-nav-cta-quote-btn"
                className="w-full rounded-none bg-[#1E3A6B] hover:bg-[#172F58] text-white"
              >
                Get a Quote
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
